import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  FileText,
  ClipboardList,
  Library,
  BarChart3,
  Settings,
  Link2,
  Target,
  Calendar,
  MessageSquare,
  X,
  GraduationCap,
  Send,
  Building2,
  Wallet,
  ChevronDown,
  ChevronRight,
  Receipt,
  Calculator,
  Gift,
  FileCheck,
  Cog,
  FileSpreadsheet,
  TrendingUp,
  DollarSign,
  Palmtree,
  Clock,
  Flag,
  Landmark,
  Shield,
} from "lucide-react";
import { useAuthStore } from "../../store/authStore";

const adminNavItems = [
  { path: "/admin", icon: LayoutDashboard, label: "Dashboard", exact: true },
  { path: "/admin/employees", icon: Users, label: "Employees" },
    { path: "/admin/appraisals", icon: ClipboardList, label: "Appraisals" },
      { path: "/admin/attendance", icon: Clock, label: "Attendance & Leaves" },
   { 
    path: "/admin/payroll", 
    icon: Wallet, 
    label: "Payroll",
    submenu: [
      { path: "/admin/payroll", icon: LayoutDashboard, label: "Dashboard", exact: true },
      // Payroll Processing
      { divider: true, label: "Processing" },
      { path: "/admin/payroll/run", icon: TrendingUp, label: "Run Payroll" },
      { path: "/admin/payroll/automation", icon: Clock, label: "Automation" },
      { path: "/admin/payroll/payslips", icon: FileSpreadsheet, label: "Payslips" },
      { path: "/admin/payroll/bonuses", icon: Gift, label: "Bonuses" },
      { path: "/admin/payroll/reimbursements", icon: Receipt, label: "Reimbursements" },
      // Configuration
      { divider: true, label: "Configuration" },
      { path: "/admin/payroll/employee-setup", icon: Users, label: "Employee Setup" },
      { path: "/admin/payroll/company-tax", icon: Building2, label: "Company Tax" },
      { path: "/admin/payroll/pay-groups", icon: Calendar, label: "Pay Groups" },
      { path: "/admin/payroll/pay-codes", icon: FileText, label: "Pay Codes" },
      { path: "/admin/payroll/salaries", icon: Calculator, label: "Salary Structures" },
      // Tax & Compliance
      { divider: true, label: "Tax & Compliance" },
      { path: "/admin/payroll/tax-liabilities", icon: Landmark, label: "Tax Liabilities" },
      { path: "/admin/payroll/state-taxes", icon: Flag, label: "State Tax Settings" },
      { path: "/admin/payroll/year-end", icon: FileCheck, label: "Year End (W-2)" },
      // Reports & Settings
      { divider: true, label: "Reports" },
      { path: "/admin/payroll/reports", icon: BarChart3, label: "Reports" },
      { path: "/admin/payroll/settings", icon: Cog, label: "Settings" },
    ]
  },
  { path: "/admin/finance", icon: DollarSign, label: "Finance" },
  { path: "/admin/compliance", icon: Shield, label: "Compliance" },
  { path: "/admin/templates", icon: FileText, label: "Templates" },
  { path: "/admin/courses", icon: GraduationCap, label: "Learning" },
  { path: "/admin/feedback", icon: MessageSquare, label: "Feedback" },
  { path: "/admin/library", icon: Library, label: "Library" },
  { path: "/admin/reports", icon: BarChart3, label: "Reports" },
  { path: "/admin/invites", icon: Link2, label: "Invite Links" },
  { path: "/admin/calendar", icon: Calendar, label: "Calendar" },
  { path: "/admin/settings", icon: Settings, label: "Settings" },
];

const ceoNavItems = [
  { path: "/ceo", icon: LayoutDashboard, label: "Dashboard", exact: true },
  { path: "/ceo/appraisals", icon: ClipboardList, label: "Appraisals" },
  { path: "/ceo/assign", icon: Send, label: "Assign Appraisal" },
  { 
    path: "/ceo/payroll", 
    icon: Wallet, 
    label: "Payroll & Leave",
    submenu: [
      { path: "/ceo/payroll", icon: TrendingUp, label: "Overview", exact: true },
      { path: "/ceo/payroll/reimbursements", icon: FileCheck, label: "Reimbursement Review" },
      { path: "/ceo/payroll/leave", icon: Palmtree, label: "Leave Review" },
      { path: "/ceo/my-payslips", icon: FileSpreadsheet, label: "My Payslips" },
      { path: "/ceo/my-salary", icon: DollarSign, label: "My Salary Info" },
      { path: "/ceo/my-reimbursements", icon: Receipt, label: "My Reimbursements" },
      { path: "/ceo/my-leave", icon: Palmtree, label: "My Leave Balance" },
    ]
  },
  { path: "/ceo/templates", icon: FileText, label: "Templates" },
  { path: "/ceo/team", icon: Building2, label: "Organization" },
  { path: "/ceo/feedback", icon: MessageSquare, label: "Feedback" },
  { path: "/ceo/attendance", icon: Clock, label: "Attendance" },
  { path: "/ceo/calendar", icon: Calendar, label: "Calendar" },
  { path: "/ceo/settings", icon: Settings, label: "Settings" },
];

const supervisorNavItems = [
  {
    path: "/supervisor",
    icon: LayoutDashboard,
    label: "Dashboard",
    exact: true,
  },
  { path: "/supervisor/team", icon: Users, label: "My Team" },
  {
    path: "/supervisor/appraisals",
    icon: ClipboardList,
    label: "Team Appraisals",
  },
   { 
    path: "/supervisor/attendance", 
    icon: Clock, 
    label: "Attendance",
    submenu: [
      { path: "/supervisor/attendance", icon: Clock, label: "Team Attendance", exact: true },
      { path: "/supervisor/payroll/leave", icon: Calendar, label: "Team Leave Requests" },
      { path: "/supervisor/my-leave", icon: Palmtree, label: "My Leave Balance" },
    ]
  },
  { 
    path: "/supervisor/payroll", 
    icon: Wallet, 
    label: "Payroll",
    submenu: [
      { path: "/supervisor/payroll", icon: Users, label: "Team Payroll", exact: true },
      { path: "/supervisor/payroll/reimbursements", icon: FileCheck, label: "Approve Reimbursements" },
      { path: "/supervisor/my-payslips", icon: FileSpreadsheet, label: "My Payslips" },
      { path: "/supervisor/my-salary", icon: DollarSign, label: "My Salary Info" },
      { path: "/supervisor/my-reimbursements", icon: Receipt, label: "My Reimbursements" },
    ]
  },
  { path: "/supervisor/courses", icon: GraduationCap, label: "Team Learning" },
  { path: "/supervisor/my-appraisal", icon: FileText, label: "My Appraisal" },
  { path: "/supervisor/feedback", icon: MessageSquare, label: "Feedback" },
  { path: "/supervisor/goals", icon: Target, label: "Goals" },
 
  { path: "/supervisor/calendar", icon: Calendar, label: "Calendar" },
  { path: "/supervisor/settings", icon: Settings, label: "Settings" },
];

const employeeNavItems = [
  { path: "/employee", icon: LayoutDashboard, label: "Dashboard", exact: true },
  { path: "/employee/appraisals", icon: ClipboardList, label: "My Appraisals" },
   { 
    path: "/employee/attendance", 
    icon: Clock, 
    label: "Attendance",
    submenu: [
      { path: "/employee/attendance", icon: Clock, label: "My Attendance", exact: true },
      { path: "/employee/payroll/leave", icon: Palmtree, label: "Leave Balance" },
    ]
  },
  { 
    path: "/employee/payroll", 
    icon: Wallet, 
    label: "Payroll",
    submenu: [
      { path: "/employee/payroll", icon: FileSpreadsheet, label: "My Payslips", exact: true },
      { path: "/employee/payroll/salary", icon: DollarSign, label: "Salary Info" },
      { path: "/employee/payroll/reimbursements", icon: Receipt, label: "Reimbursements" },
    ]
  },
  { path: "/employee/courses", icon: GraduationCap, label: "My Learning" },
  { path: "/employee/goals", icon: Target, label: "My Goals" },
  { path: "/employee/feedback", icon: MessageSquare, label: "Feedback" },
  { path: "/employee/compliance", icon: Shield, label: "Compliance" },
  { path: "/employee/calendar", icon: Calendar, label: "Calendar" },
  { path: "/employee/settings", icon: Settings, label: "Settings" },
];

export default function Sidebar({ isOpen, onClose }) {
  const { user } = useAuthStore();
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({});

  const getNavItems = () => {
    switch (user?.role) {
      case "admin":
        return adminNavItems;
      case "ceo":
        return ceoNavItems;
      case "supervisor":
        return supervisorNavItems;
      case "employee":
        return employeeNavItems;
      default:
        return [];
    }
  };

  const navItems = getNavItems();

  const isActive = (item) => {
    if (item.exact) {
      return location.pathname === item.path;
    }
    return location.pathname.startsWith(item.path);
  };

  const isSubmenuActive = (item) => {
    if (!item.submenu) return false;
    return item.submenu.filter(subItem => !subItem.divider).some(subItem => {
      if (subItem.exact) {
        return location.pathname === subItem.path;
      }
      return location.pathname.startsWith(subItem.path);
    });
  };

  const toggleMenu = (path) => {
    setExpandedMenus(prev => ({
      ...prev,
      [path]: !prev[path]
    }));
  };

  // Auto-expand menu if a submenu item is active
  React.useEffect(() => {
    navItems.forEach(item => {
      if (item.submenu && isSubmenuActive(item)) {
        setExpandedMenus(prev => ({
          ...prev,
          [item.path]: true
        }));
      }
    });
  }, [location.pathname]);

  const renderNavItem = (item) => {
    const Icon = item.icon;
    const active = isActive(item);
    const hasSubmenu = item.submenu && item.submenu.length > 0;
    const isExpanded = expandedMenus[item.path];
    const submenuActive = isSubmenuActive(item);

    if (hasSubmenu) {
      return (
        <div key={item.path} className="space-y-1">
          <button
            onClick={() => toggleMenu(item.path)}
            className={`
              w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium
              transition-all duration-200
              ${
                submenuActive
                  ? "bg-teal-50 text-teal-700"
                  : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
              }
            `}
          >
            <Icon
              className={`w-5 h-5 ${
                submenuActive ? "text-teal-600" : "text-gray-400"
              }`}
            />
            {item.label}
            <div className="ml-auto">
              {isExpanded ? (
                <ChevronDown className="w-4 h-4" />
              ) : (
                <ChevronRight className="w-4 h-4" />
              )}
            </div>
          </button>
          
          {isExpanded && (
            <div className="ml-4 pl-4 border-l border-gray-200 space-y-1">
              {item.submenu.map((subItem, index) => {
                // Handle divider
                if (subItem.divider) {
                  return (
                    <div key={`divider-${index}`} className="pt-2 pb-1">
                      <div className="border-t border-gray-200" />
                      <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider px-3 pt-2 block">
                        {subItem.label}
                      </span>
                    </div>
                  );
                }
                
                const SubIcon = subItem.icon;
                const subActive = subItem.exact 
                  ? location.pathname === subItem.path 
                  : location.pathname === subItem.path || location.pathname.startsWith(subItem.path + '/');
                
                return (
                  <NavLink
                    key={subItem.path}
                    to={subItem.path}
                    onClick={onClose}
                    className={`
                      flex items-center gap-3 px-3 py-2 rounded-lg text-sm
                      transition-all duration-200
                      ${
                        subActive
                          ? "bg-teal-50 text-teal-700 font-medium"
                          : "text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                      }
                    `}
                  >
                    <SubIcon
                      className={`w-4 h-4 ${
                        subActive ? "text-teal-600" : "text-gray-400"
                      }`}
                    />
                    {subItem.label}
                    {subActive && (
                      <div className="ml-auto w-1.5 h-1.5 bg-teal-500 rounded-full" />
                    )}
                  </NavLink>
                );
              })}
            </div>
          )}
        </div>
      );
    }

    return (
      <NavLink
        key={item.path}
        to={item.path}
        onClick={onClose}
        className={`
          flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium
          transition-all duration-200
          ${
            active
              ? "bg-teal-50 text-teal-700"
              : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
          }
        `}
      >
        <Icon
          className={`w-5 h-5 ${
            active ? "text-teal-600" : "text-gray-400"
          }`}
        />
        {item.label}
        {active && (
          <div className="ml-auto w-1.5 h-1.5 bg-teal-500 rounded-full" />
        )}
      </NavLink>
    );
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed top-16 left-0 bottom-0 w-64 bg-white border-r border-gray-200 z-40
          transform transition-transform duration-300 ease-in-out overflow-y-auto
          lg:translate-x-0
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
        `}
      >
        {/* Mobile close button */}
        <button
          onClick={onClose}
          className="lg:hidden absolute top-4 right-4 p-1 hover:bg-gray-100 rounded-lg"
        >
          <X className="w-5 h-5 text-gray-500" />
        </button>

        <nav className="p-4 space-y-1 mt-2 lg:mt-0">
          {navItems.map((item) => renderNavItem(item))}
        </nav>
      </aside>
    </>
  );
}
